import React, {useState, useEffect, Fragment, useCallback} from 'react';
import localization from 'assets/localization/localization';
import {STATUS} from 'constants/statusConstant';
import DivLayout from 'components/sales/divLayout/divLayout';
import DocumentView from "../../../../components/sales/downloadDocView/documentView";
import Layout from "../../../../components/sales/layout/layout";
import './view.css'

const DealerView = ({
                        ucdViewRequest,
                        match,
                        ucdViewResponse = []
                    }) => {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            await ucdViewRequest(match?.params?.id)
        })();
        setIsLoading(false);
    }, []);

    return (
        <Layout
            title={localization.BacktoList}
            isGoback
            isLoading={isLoading}
        >
            <Fragment>
                {ucdViewResponse?.data && (
                    <>
                        <div className="panel-card">
                            <div className="panel-heading">
                                Dealer Details
                            </div>
                            <div className="panel-body">

                                <div className="details-listing">
                                    {ucdViewResponse?.data &&
                                        <>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Business Name"}
                                                        data={
                                                            ucdViewResponse?.data?.business_name
                                                                ? ucdViewResponse?.data?.business_name
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Owner Name"}
                                                        data={
                                                            ucdViewResponse?.data.owner_name
                                                                ? ucdViewResponse?.data?.owner_name
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Firm Type"}
                                                        data={
                                                            ucdViewResponse?.data?.firm_type
                                                                ? ucdViewResponse?.data?.firm_type
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Channel Type"}
                                                        data={
                                                            ucdViewResponse?.data?.channel_type
                                                                ? ucdViewResponse?.data?.channel_type
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Organization Type"}
                                                        data={
                                                            ucdViewResponse?.data?.organization_type
                                                                ? ucdViewResponse?.data?.organization_type
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"GST No."}
                                                        data={
                                                            ucdViewResponse?.data?.dealer_gst_no
                                                                ? ucdViewResponse?.data?.dealer_gst_no
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"PAN No."}
                                                        data={
                                                            ucdViewResponse?.data?.dealer_pan_no
                                                                ? ucdViewResponse?.data?.dealer_pan_no
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Eamil"}
                                                        data={
                                                            ucdViewResponse?.data?.registration_email
                                                                ? ucdViewResponse?.data?.registration_email
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Registration Phone No."}
                                                        data={
                                                            ucdViewResponse?.data?.registration_mobile_no
                                                                ? ucdViewResponse?.data?.registration_mobile_no
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Aadhar No."}
                                                        data={
                                                            ucdViewResponse?.data?.aadhar_no
                                                                ? ucdViewResponse?.data?.aadhar_no
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"MSME Certificate"}
                                                        data={
                                                            ucdViewResponse?.data?.msme_certificate
                                                                ? ucdViewResponse?.data?.msme_certificate
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"MSME No"}
                                                        data={
                                                            ucdViewResponse?.data?.msme_no
                                                                ? ucdViewResponse?.data?.msme_no
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Bank Name"}
                                                        data={
                                                            ucdViewResponse?.data?.bank_name
                                                                ? ucdViewResponse?.data?.bank_name
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Account No."}
                                                        data={
                                                            ucdViewResponse?.data?.account_no
                                                                ? ucdViewResponse?.data?.account_no
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"IFSC Code"}
                                                        data={
                                                            ucdViewResponse?.data?.ifsc_code
                                                                ? ucdViewResponse?.data?.ifsc_code
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Account Type"}
                                                        data={
                                                            ucdViewResponse?.data?.account_type
                                                                ? ucdViewResponse?.data?.account_type
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DivLayout
                                                        heading={"Branch Name"}
                                                        data={
                                                            ucdViewResponse?.data?.branch_name
                                                                ? ucdViewResponse?.data?.branch_name
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                                {ucdViewResponse?.data?.upload_cancelled_cheque &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={ucdViewResponse?.data?.upload_cancelled_cheque}
                                                            title={"Cancelled Cheque"}
                                                        />
                                                    </div>
                                                }


                                                {ucdViewResponse?.data?.gst_certificate_photo &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={ucdViewResponse?.data?.gst_certificate_photo}
                                                            title={"GST Certificate"}
                                                        />
                                                    </div>
                                                }
                                                {ucdViewResponse?.data?.pan_card_photo &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={ucdViewResponse?.data?.pan_card_photo}
                                                            title={"Pan Card"}
                                                        />
                                                    </div>
                                                }
                                                {ucdViewResponse?.data?.msme_declaration_photo &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={ucdViewResponse?.data?.msme_declaration_photo}
                                                            title={"MSME Declaration"}
                                                        />
                                                    </div>
                                                }

                                                {ucdViewResponse?.data?.msme_certificate_photo &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={ucdViewResponse?.data?.msme_certificate_photo}
                                                            title={"MSME Certificate"}
                                                        />
                                                    </div>
                                                }

                                                {ucdViewResponse?.data?.selfie_with_dsa &&
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={ucdViewResponse?.data?.selfie_with_dsa}
                                                            title={"Selfie With DSA"}
                                                        />
                                                    </div>
                                                }

                                            </div>
                                        </>
                                    }


                                </div>
                            </div>
                        </div>
                        <div className="panel-card">
                            <div className="panel-heading">
                                Dealer Images
                            </div>
                            <div className="panel-body">

                                <div className="details-listing">
                                    <div className="row">
                                        {ucdViewResponse?.data?.dealer_images && ucdViewResponse?.data?.dealer_images.map((val, i) => {
                                            return (
                                                <div className="col-6">
                                                    <DocumentView
                                                        attachment={val}
                                                        title={""}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>

                )}
            </Fragment>
        </Layout>
    );
};

export default DealerView;
